<a class="header-cart" [routerLink]="'/cart'">

  <div class="header-cart__icon">
    <nb-icon icon="shopping-cart-outline"/>
  </div>

  <div class="header-cart__info" (click)="toCart()">
    <p *ngIf="amount$ | async as amount; else emptyCart">
      {{ createLabel(amount, 'товар|товара|товаров') }}
    </p>
    <small *ngIf="cost$ | async as cost">
        <span class="price-main">{{ (cost | formatPriceNumber).main }}</span>
        <span class="price-cents">.{{ (cost | formatPriceNumber).cents }}</span>
        <span>₽</span>
    </small>
  </div>
</a>

<ng-template #emptyCart>
  <small i18n="@@Empty">Пусто</small>
</ng-template>
